import React, {
  Component,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import CartContext from "./CartContext";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";

export default class Settings extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      autoScan: true,
      showNumberKeys: true,
      productView: "list",
    };
  }

  handleAutoScan = (event) => {
    this.setState({ autoScan: !this.state.autoScan });
    this.context.SetAutoScan(!this.state.autoScan);
    localStorage.setItem("autoScan", !this.state.autoScan);
  };
  handleShowNumberKeys = (event) => {
    this.setState({ showNumberKeys: !this.state.showNumberKeys });
    this.context.SetShowNumberKeys(!this.state.showNumberKeys);
    localStorage.setItem("showNumberKeys", !this.state.showNumberKeys);
  };
  handleProductView = (event) => {
    this.setState({ productView: event.target.value });
    this.context.SetProductView(event.target.value);
    localStorage.setItem("productView", event.target.value);
  };

  componentDidMount() {
    this.setState({ autoScan: this.context.autoScan });
    this.setState({ showNumberKeys: this.context.showNumberKeys });
    this.setState({ productView: this.context.productView });
  }
  render() {
    return (
      <Modal
        {...this.props}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="bg-warning">
          <Modal.Title id="contained-modal-title-vcenter">Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid ">
          <Row className="mb-3">
            <Col> Auto Scan on SKU</Col>
            <Col>
              <Form.Check
                className=""
                type="checkbox"
                checked={this.state.autoScan}
                name="autoScan"
                label={""}
                onChange={this.handleAutoScan}
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              ></Form.Check>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col> Show Number Keys</Col>
            <Col>
              <Form.Check
                className=""
                type="checkbox"
                checked={this.state.showNumberKeys}
                name="showNumberKeys"
                label={""}
                onChange={this.handleShowNumberKeys}
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              ></Form.Check>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col> Product View Style</Col>
            <Col>
              <Form.Select
                className=""
                type="text"
                value={this.state.productView}
                name="productView"
                label={""}
                onChange={this.handleProductView}
              >
                <option value="grid">Grid View</option>
                <option value="list">List View</option>
              </Form.Select>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          {/* <Button variant="primary" size="lg" onClick={this.handleSubmit}>
            Save
          </Button> */}

          <Button variant="danger" size="lg" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
